(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-mod-action-reels"] && !Shopify.designMode) return;
  try {
    
function ovBindReels(scope){scope.querySelectorAll('video.ov-three-second-video').forEach(video=>{if(video.dataset.ovBound)return;video.dataset.ovBound='true';video.addEventListener('timeupdate',()=>{if(video.currentTime>=3){video.currentTime=0;if(!video.paused)video.play().catch(()=>{});}});});}
ovBindReels(document);document.addEventListener('shopify:section:load',e=>ovBindReels(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ovellor-ticker"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
 const button = event.target.closest('.ov-ticker__pause');
 if (!button) return;
 const paused = button.getAttribute('aria-pressed') !== 'true';
 button.setAttribute('aria-pressed', String(paused));
 button.setAttribute('aria-label', paused ? 'המשך הטקסט הנע' : 'השהיית הטקסט הנע');
 button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
 button.closest('[data-ov-ticker]').classList.toggle('is-paused', paused);
});

  } catch(e) { console.error(e); }
})();
})();
